import { render, staticRenderFns } from "./ReviewsPercentages.vue?vue&type=template&id=dd5aa028&"
import script from "./ReviewsPercentages.vue?vue&type=script&lang=js&"
export * from "./ReviewsPercentages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports